import { FormatAlignCenter } from "@mui/icons-material";
import { indexOf, map, uniq } from "lodash";
import { IEntityFlags, notesInitializationValue } from "../slices/candidateSlice";
import { v4 as uuidv4 } from 'uuid';
import { FLAG_VALUES } from "../../library/constants/flagColors";

const initialFlagModel: IEntityFlags[] = [
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Allegiance to the United States'
    },
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Foreign Influence'
    },
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Foreign Preference'
    },
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Sexual Behavior'
    },
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Personal Conduct'
    },
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Incarceration'
    },
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Financial Considerations'
    },
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Alcohol Consumption'
    },
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Drug Involvement'
    },
    {
        id: uuidv4(),
        entityId: '',
        type: FLAG_VALUES.SAFE,
        value: 0,
        name: 'Emotional, Mental, Personality Disorders'
    }
]

export const mapFlags = (flags: IEntityFlags[]): IEntityFlags[] => {
    const returnValue = [...initialFlagModel];
    (flags || []).forEach((originalFlag) => { 
        const flag = { ...originalFlag };
        if (flag.flagType) {
            flag.type = flag.flagType;
        }
        if (flag.name && flag.type) {
            if (!flag.value || flag.value === 0) {
                flag.value = 1;
            }
            const flagTypes = map(returnValue, (returnFlag) => returnFlag.name.toLowerCase().trim() );
            const index = indexOf(flagTypes, flag.name.toLowerCase().trim());
            
            if (index !== -1) {
                returnValue.splice(index, 1, {
                    ...returnValue[index],
                    type: flag.type,
                    value: returnValue[index].value + flag.value
                });
            } else {
                returnValue.push(flag);
            }
        }
    })
    return returnValue;
}

export const mapNotes = (notes: any[]) => {
    const returnValue: any = {...notesInitializationValue};
    notes.forEach((note) => {
        returnValue[note.name] = note;
    })
    return returnValue;
}

export const mapAttributes = (candidateAttributes: { [key: string]: string[] }): { [key: string]: string[] } => {
    const returnValue: { [key: string]: string[] } = {}
    const keys = Object.keys(candidateAttributes);
    keys.forEach((key) => {
        returnValue[key] = uniq(candidateAttributes[key]);
    });
    return returnValue;
}